import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { CHANGE_PASSWORD_SUCCESS } from '../../redux/modules/auth';
import {
  Row,
  FormGroup,
  ControlLabel,
  FormControl,
  Form,
  Col
} from 'react-bootstrap';
import i18n from 'kodyl-js/i18n/react';
import LoadingSpinner from '../../common/loading-spinner';

@i18n
class ChangePassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status: false,
      loading: false,
      msg: null
    };
  }

  handleSubmit = event => {
    event.preventDefault();

    const oldPasswordVal = this.oldPassword
      ? ReactDOM.findDOMNode(this.oldPassword).value
      : undefined;
    const newPasswordVal = ReactDOM.findDOMNode(this.newPassword).value;
    const newPassword2Val = ReactDOM.findDOMNode(this.newPassword2).value;

    if (!newPasswordVal || !newPassword2Val) {
      return this.setState({
        status: true,
        msg: this.i18n('Password is missing'),
        loading: false
      });
    }

    if (newPasswordVal !== newPassword2Val) {
      return this.setState({
        status: true,
        msg: this.i18n(
          'Hovsa! Adgangskoderne er ikke ens. Prøv venligst igen.'
        ),
        loading: false
      });
    }
    this.setState({ loading: true, status: false });
    this.props
      .changePassword({
        newPassword: newPasswordVal,
        oldPassword: oldPasswordVal
      })
      .then(action => {
        if (action.type === CHANGE_PASSWORD_SUCCESS) {
          this.setState({
            status: CHANGE_PASSWORD_SUCCESS,
            msg: this.i18n('Sådan! Din adgangskode er nu ændret.'),
            loading: false
          });
          return action;
        }
        this.setState({
          status: true,
          msg: this.i18n(
            'An error occurred. Please try again or contact customer support.'
          ),
          loading: false
        });
        return action;
      })
      .catch(err => {
        if (__DEV__) {
          console.error(err);
        }
        this.setState({
          status: true,
          msg: this.i18n(
            'An error occurred. Please try again or contact customer support.'
          ),
          loading: false
        });
      });
  };

  render() {
    const { meta = [] } = this.props.user || {};
    const { status, loading, msg } = this.state;

    return (
      <div id="profile-change-password">
        <Form
          horizontal
          onSubmit={this.handleSubmit}
          name="form"
          className="change-password"
        >
          <div className="form-section">
            {!meta.filter(
              ({ identifier, value }) => identifier === 'missingPw' && value
            ).length ? (
              <FormGroup>
                <Col componentClass={ControlLabel} sm={4}>
                  {this.i18n(`${this.i18n('Current Password')} *`)}
                </Col>
                <Col sm={8}>
                  <FormControl
                    ref={ref => (this.oldPassword = ref)}
                    type="password"
                    placeholder={this.i18n('Current Password')}
                    name="oldPassword"
                    required
                  />
                  <FormControl.Feedback />
                </Col>
              </FormGroup>
            ) : null}
            <FormGroup>
              <Col componentClass={ControlLabel} sm={4}>
                {`${this.i18n('Desired password')} *`}
              </Col>
              <Col sm={8}>
                <FormControl
                  type="password"
                  name="new-password"
                  placeholder={this.i18n('Desired password')}
                  ref={ref => (this.newPassword = ref)}
                  required
                />
                <FormControl.Feedback />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col componentClass={ControlLabel} sm={4}>
                {`${this.i18n('Desired password again')} *`}
              </Col>
              <Col sm={8}>
                <FormControl
                  type="password"
                  name="new-password2"
                  placeholder={this.i18n('Desired password again')}
                  ref={ref => (this.newPassword2 = ref)}
                  required
                />
                <FormControl.Feedback />
              </Col>
            </FormGroup>
            <Row className="form-group">
              <div className="col-sm-offset-4 col-sm-8">
                <button
                  type="submit"
                  disabled={loading}
                  className="btn btn-primary"
                >
                  <i
                    className="fa fa-unlock"
                    style={{
                      marginRight: '0.5em',
                      width: '1.28571429em',
                      textAlign: 'center'
                    }}
                  />
                  {this.i18n('Change Password')}
                </button>
              </div>
            </Row>
          </div>
        </Form>
        {loading ? <LoadingSpinner /> : null}
        {status ? (
          <div
            className={`alert ${
              status === CHANGE_PASSWORD_SUCCESS ? 'alert-info' : 'alert-danger'
            } alert-last-dwelling`}
            role="alert"
          >
            {msg}
          </div>
        ) : null}
      </div>
    );
  }
}

export default ChangePassword;
